export class GoogleSigninHelper {

    public static tokenClient: google.accounts.oauth2.TokenClient;

    // /**
    //  * api: https://developers.google.com/identity/gsi/web/reference/html-reference#data-context
    //  * @param dataContext 
    //  */
    public static loadGoogleSigninScriptLabel() {
        const url = 'https://accounts.google.com/gsi/client';
        const locale = "en_US";
        const queryString = `?hl=${locale}`;
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = url + queryString;
        script.async = true;
        script.defer = true;

        // window.handleCredentialResponse = GoogleSigninHelper.handleCredentialResponse;

        document.body.appendChild(script);
    }

    private static parseJwt(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    }

    private static handleCredentialResponse(response) {
        const payload = GoogleSigninHelper.parseJwt(response.credential);
        console.log(payload);
    }
    
    public static signInCallback(res) {
        if (res) {

        }
    }
    
    public static signInErrorCallback() {
        
    }
}

/* 
 * demo tutorial: https://www.wfublog.com/2023/02/google-people-api-2023.html
*/
// 载入 gsi sdk
// $.getScript("https://accounts.google.com/gsi/client", function() {
//     tokenClient = google.accounts.oauth2.initTokenClient({
//         client_id: client_id,
//         scope: scope,
//         callback: signIn_callback,
//         error_callback: error_callback
//     });
// });